import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: grid;
  }
`;
export const UserSoldContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  margin-top: 40px;

  @media (max-width: 768px) {
    width: auto;
  }
`;
export const UserSoldLeftContainer = styled.div`
  border: 3px solid #7e7d7a;

  display: flex;
  flex-direction: column;
  margin-right: 50px;
  width: 25%;
  height: 60%;
  border-radius: 15px;

  i {
    margin: 8px 8px;
    font-size: 40px;
  }
`;
export const PerfilPictureContainer = styled.div`
  .perfil-picture-background {
    border-radius: 50%;
    border: 6px solid black;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 251px;
    height: 251px;
    margin: 20px 50px;
  }

  img {
    width: 244px;
    height: 244px;
    border-radius: 50%;
  }
`;
export const UserSoldFeatureContainerBotton = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin: 30px;
`;
export const PerfilNameSinceContainer = styled.div`
  .user-name-container {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #002666;
    font-weight: bold;
  }

  .user-since-container {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #535353;
    font-weight: bold;
    font-size: 12px;
  }
`;
export const MySellerContainer = styled.div`
  margin-top: 10px;

  .my-seller {
    color: #303030;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .my-seller-secondary-property {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin: 20px;
    list-style: none;
  }
`;
export const MyPurchaseContainer = styled.div`
  color: #303030;
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const PaymentContainer = styled.div`
  color: #303030;
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ConfigurationContainer = styled.div`
  .configuration {
    color: #303030;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .configuration-secondary-property {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin: 20px;
    list-style: none;
  }
`;

// >>>>>>>>>>>CONTAINER DIREITO<<<<<<<<<<

export const UserPaymentRightContainer = styled.div`
  border: 3px solid #7e7d7a;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  width: 100%;
`;
export const UserPaymentTopContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export const UserPaymentTitle = styled.div`
  border-bottom: 3px solid #d8e0ea;
  padding: 8px;
  display: flex;
  margin: 20px;
  color: #002666;
  font-size: 26px;
  margin-bottom: 6px;
  margin-top: 20px;
  align-items: center;
  i {
    font-size: 60px;
    margin-right: 20px;
  }
`;
export const SecondaryTopLeftContainer = styled.div`
  background: #cbcbcb;
  display: flex;
  margin: 20px 10px 20px 20px;
  padding: 20px;
  width: 48%;
  flex-direction: column;
  border-radius: 10px;
  min-height: 250px;
  span {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
`;
export const TitleAndSearch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  h2 {
    font-size: 1.75rem;
  }
  input {
    background-color: transparent;
    border: solid 1px;
    border-radius: 15px;
    width: 120px;
    &::placeholder {
      color: #002666;
    }
  }

  i {
    z-index: 1;
    left: -22px;
    position: relative;
  }
`;

export const SecondaryTopRightContainer = styled.div`
  background: #002666;
  color: white;
  display: flex;
  margin: 20px 20px 20px 10px;
  padding: 20px;
  flex-direction: column;
  border-radius: 10px;
  width: 48%;
  height: auto;
  align-items: center;
  h2 {
    font-size: 16px;
  }
  h1 {
    font-size: 32px;
  }
  h3 {
    margin-top: 20px;
    font-size: 14px;
    font-weight: bold;
  }
  button {
    background: #ce1720;
    color: white;
    text-align: center;
    width: 75%;
    height: 60px;
    border-radius: 10px;
    font-weight: bold;
    font-size: 24px;
    margin-top: 25px;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
`;
// >>>>>>>>>>>>>>>>>>>Container BOT<<<<<<<<<<<<<<<<<<<<<

export const UserPaymentBotContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  margin-left: 5px;
  font-weight: bold;
  width: 100%;

  @media (max-width: 768px) {
    align-items: center;
    margin-right: 80px;
    padding: 5px;
    table,
    th,
    td {
      font-size: 16px;
      border: 20px solid #f8f8f8;
    }
  }

  .status-yes {
    color: green;
  }
  .status-no {
    color: #ce1720;
  }

  .number {
    color: #002666;
    text-decoration: underline #7e7d7a;
  }

  table {
    tr {
      margin-left: 100px;
    }
  }

  button {
    background: #ce1720;
    color: white;
    text-align: center;
    width: 50%;
    height: 45%;
    border-radius: 10px;
    font-weight: bold;
    font-size: 20px;
    margin: 10px 10px;

    @media (max-width: 768px) {
      width: 60%;
      font-size: 12px;
    }
  }

  span {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    text-decoration: underline #7e7d7a;
    margin-right: 80px;
    padding: 20px;
  }
`;

export const PlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: 768px) {
    display: grid;
  }

  .signup-content {
    h3 {
      color: #002666;
      font-weight: bold;
    }

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 20px;
      }

      input {
        border: 2px solid #303030;
        border-radius: 10px;
        width: 100%;
        height: 80px;
        font-size: 24px;
        padding-left: 20px;
        color: #bcbcbc;
      }
    }
  }

  .signup-top-section {
    padding: 70px 0;

    form {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
      }
    }

    .profile-photo-upload-button-wrapper {
      position: relative;
      overflow: hidden;
      display: inline-block;
    }

    .profile-photo-upload-button-wrapper input[type='file'] {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      font-size: 100px;
    }
  }

  .signup-top-section-left {
    width: 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    input {
      border: none;
      padding: 10px 40px;
      width: 265px;
      background: #ce1720;
      color: #fff;
      border-radius: 10px;
      font-size: 24px;
      font-weight: bold;
    }
  }

  #signup_photo_img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .signup-photo-circle {
    border: 3px dashed #303030;
    color: #303030;
    height: 350px;
    width: 350px;
    margin: 40px 0;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      font-size: 18px;
    }

    i {
      font-size: 50px;
      margin-bottom: 15px;
    }
  }

  .signup-top-section-right {
    width: 60%;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .signup-form-row {
    display: flex;
    flex-direction: row;

    div {
      width: 100%;
    }
  }

  .signup-mid-section {
    width: 90%;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }

    h1 {
      color: #fff;
      font-size: 48px;
      margin-top: 70px;
      margin-bottom: 100px;
      font-weight: bold;
    }
  }
  .signup-mid {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .sms-checkbox-wrapper {
    border: 2px solid #303030;
    border-radius: 5px;
    padding: 5px;
    margin-right: 10px;
    cursor: pointer;
  }

  .signup-plan-card {
    background: #fff;
    width: 31%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    text-align: center;

    @media (max-width: 768px) {
      width: 70%;
      margin-bottom: 20px;
    }

    h3 {
      border-bottom: 2px solid #e7e6e6;
      font-size: 20px;
      padding-top: 30px;
      padding-bottom: 15px;
    }

    h2 {
      border-bottom: 2px solid #e7e6e6;
      font-size: 40px;
      margin-bottom: 20px;
      padding-bottom: 10px;
      font-weight: bold;
    }

    span {
      font-size: 20px;
      font-weight: normal;
      position: relative;
      top: -15px;
    }

    strong {
      font-size: 16px;
      font-weight: normal;
      font-variant-position: sub;
    }

    p {
      border-bottom: 2px solid #e7e6e6;
      color: #737373;
      font-size: 18px;
      margin: 20px 50px 0 50px;
    }

    button {
      border: none;
      border-radius: 10px;
      background: #009fea;
      color: #fff;
      font-size: 22px;
      margin-top: 30px;
      margin-bottom: 60px;
      padding: 15px 60px;
    }

    /* .select-container {
        border: 1px dashed red;
    } */
    .select-container {
      font-size: 10px;
    }

    /*.select-container:after {
        content: '\f078';
        font: normal normal normal 17px/1 FontAwesome;
    } */

    i {
      color: #009fea;
      font-size: 18px;
      position: relative;
      bottom: 20px;
      left: 40%;
    }

    select {
      width: 100%;
      border: none;
      background: rgba(0, 0, 0, 0);
      color: #737373;
      font-size: 16px;
      /* Remove ícone dropdown padrão */
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }

    /* Remove ícone dropdown padrão no IE11.
       Um hack pras bosta da Microsoft... */
    select::-ms-expand {
      display: none;
    }

    select:hover {
      background: #009fea;
      color: #fff;
    }

    &:hover {
      background: #009fea;
      color: #fff;
      cursor: pointer;

      h2,
      h3,
      p {
        border-color: #00b4e9;
        color: #fff;
      }

      button {
        background: #0e0e0e;
      }

      select {
        color: white;
      }

      i {
        color: white;
      }
    }
  }

  .signup-plan-card-selected {
    background: #009fea;
    color: #fff;

    h2,
    h3,
    p {
      border-color: #00b4e9;
      color: #fff;
    }

    button {
      background: #0e0e0e;
    }

    select {
      color: white;
    }

    i {
      color: white;
    }
  }

  .signup-bot-section {
    padding: 110px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    button {
      border: none;
      border-radius: 10px;
      background: #ce1720;
      color: #fff;
      font-size: 28px;
      font-weight: bold;
      padding: 20px 80px;
    }

    p {
      color: #fff;
      font-size: 22px;
      position: relative;
      margin-bottom: -30px;
      top: 30px;
    }
  }
`;
